import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Next from "../../../assets/next.svg";
import {
    ContainerHeaderTable,
    HeaderTable,
    TextHeaderTable
} from "../../../components/HeaderTable/styles";
import NamePages from "../../../components/NamePages";
import Toast from "../../../components/Toast";
import BoxRequisicao from "../../../components/box-listas/box-requisicao";
import ButtonOrderBy from "../../../components/buttonOrderBy";
import { RowButtonsOrderby } from "../../../components/buttonOrderBy/styles";
import Header from "../../../components/header/header";
import api from "../../../services/api";
import { toastProps } from "../../../utils/toastProps";
import {
    BotoesNavegar,
    Box,
    Buscar,
    InlineStyle,
    InlineStylePages,
    Paginas,
    Tela,
} from "../ingredientes/ingredientes-style";
import { Buscar2 } from "../usuarios/usuarios-style";

function Requisicoes() {
    const [requisicao, setRequisicao] = useState([]);
    const [numeroDaPagina, setNumeroDaPagina] = useState(1);
    const [numeroTotalPaginas, setNumeroTotalPaginas] = useState(1);
    const [isEmpty, setIsEmpty] = useState(false);
    const [orderBySelect, setOrderBySelect] = useState("nome");
    const [typeOrder, setTypeOrder] = useState("ascendent");
    const [busca, setBusca] = useState("");
    const [statusFiltro, setStatusFiltro] = useState("");
    const [dataFiltro, setDataFiltro] = useState("");

    const onPressButtonOrder = (order) => {
        console.log("order", order);
        console.log("orderBySelect", orderBySelect);
        if (order === orderBySelect) {
            typeOrder === "ascendent"
                ? setTypeOrder("descendent")
                : setTypeOrder("ascendent");
        } else {
            setTypeOrder("ascendent");
            setOrderBySelect(order);
        }
    };

    // MODIFICADO - Função atualizada para incluir busca e filtros
    const buildFilterParams = () => {
        let params = '';
        if (statusFiltro === 'null') {
            params += '&status_requisicao__isnull=true';
        } else if (statusFiltro) {
            params += `&status_requisicao=${statusFiltro}`;
        }
        if (dataFiltro) {
            params += `&created_at__date=${dataFiltro}`;
        }
        return params;
    };

    const getRecomendations = () => {
        const filterParams = buildFilterParams();
        console.log(
            "requisicao",
            `/api/sugestoes?ordering=${typeOrder === "ascendent" ? "" : "-"
            }${orderBySelect}&page=1&find=${busca}${filterParams}`
        );
        api
            .get(
                `/api/sugestoes?ordering=${typeOrder === "ascendent" ? "" : "-"
                }${orderBySelect}&page=1&find=${busca}${filterParams}`
            )
            .then(function (response) {
                if (response.data.results.length === 0) {
                    setIsEmpty(true);
                } else {
                    setIsEmpty(false);
                }
                console.log("\nresposta", response.data.results);
                setRequisicao(response.data.results);
                console.log(response.data.results, "teste");
                setNumeroDaPagina(1);
                setNumeroTotalPaginas(Math.ceil(response.data.count / 15));
            })
            .catch((err) => {
                toast.error("Erro ao carregar as requisições", toastProps);
                console.log(err);
            });
    };

    // MODIFICADO - Adicionar busca como dependência e debounce
    useEffect(() => {
        const timer = setTimeout(() => getRecomendations(), 500);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderBySelect, typeOrder, busca, statusFiltro, dataFiltro]);

    // MODIFICADO - Atualizar para incluir busca
    const PaginaAtual = async (data) => {
        if (data > 0 && data <= numeroTotalPaginas) {
            setNumeroDaPagina(data);
            const filterParams = buildFilterParams();
            const response = await api.get(
                `/api/sugestoes?ordering=${typeOrder === "ascendent" ? "" : "-"
                }${orderBySelect}&page=${data}&find=${busca}${filterParams}`
            );
            setRequisicao(response.data.results);
            console.log(response.data.results, "testando");
        }
    };

    // MODIFICADO - Atualizar SearchPagina para incluir busca
    const SearchPagina = async (data) => {
        const filterParams = buildFilterParams();
        if (data === "") {
            setNumeroDaPagina(1);
            const response = await api.get(`/api/sugestoes/?page=${1}&find=${busca}${filterParams}`);
            setRequisicao(response.data.results);
            console.log(response.data.results, "Oi123");
        } else {
            setNumeroDaPagina(data);
            const response = await api.get(`/api/sugestoes/?page=${data}&find=${busca}${filterParams}`);
            setRequisicao(response.data.results);
            console.log(response.data.results, "Oi123");
        }
    };

    return (
        <>
            <Toast />
            <div>
                <Header />
                <NamePages BackgroundColor={"#879F85"} NamePage={"Requisições"} />
                <Tela>
                    {/* ADICIONADO - Barra de pesquisa */}
                    <InlineStyle>
                        <Buscar style={{ width: "400px" }}>
                            <SearchIcon />
                            <input
                                type="text"
                                placeholder="Buscar por nome, marca ou data (DD/MM/AAAA)..."
                                onChange={(event) => setBusca(event.target.value)}
                                value={busca}
                                style={{ width: "100%" }}
                            />
                        </Buscar>

                        {/* Filtro de Status */}
                        <select
                            style={{
                                height: "40px",
                                borderRadius: "10px",
                                border: "none",
                                padding: "0 10px",
                                marginLeft: "10px",
                                backgroundColor: "#f0f0f0"
                            }}
                            value={statusFiltro}
                            onChange={(e) => setStatusFiltro(e.target.value)}
                        >
                            <option value="">Todos os Status</option>
                            <option value="null">Sem Status</option>
                            <option value="pendente">Pendente</option>
                            <option value="em_cadastro">Em Cadastro</option>
                            <option value="aguardando_info">Aguardando Info</option>
                            <option value="erro">Com Erro</option>
                            <option value="duplicada">Duplicada</option>
                        </select>

                        {/* Filtro de Data */}
                        <input
                            type="date"
                            style={{
                                height: "40px",
                                borderRadius: "10px",
                                border: "none",
                                padding: "0 10px",
                                marginLeft: "10px",
                                backgroundColor: "#f0f0f0"
                            }}
                            value={dataFiltro}
                            onChange={(e) => setDataFiltro(e.target.value)}
                        />
                    </InlineStyle>

                    {isEmpty ? null : (
                        <InlineStylePages>
                            {numeroDaPagina > 1 ? (
                                <BotoesNavegar
                                    type="button"
                                    onClick={() => PaginaAtual(numeroDaPagina - 1)}
                                >
                                    <img src={Next} alt="Voltar" className="rotateimg180" />
                                </BotoesNavegar>
                            ) : null}
                            <Paginas>
                                {numeroDaPagina > 10 ? (
                                    <button onClick={() => PaginaAtual(1)}>{1}</button>
                                ) : null}
                                {numeroDaPagina > 10 ? (
                                    <button onClick={() => PaginaAtual(2)}>{2}</button>
                                ) : null}
                                {numeroDaPagina > 10 ? <h3>...</h3> : null}
                                <button
                                    onClick={() => PaginaAtual(numeroDaPagina)}
                                    style={{ backgroundColor: "rgb(135, 159, 133)" }}
                                >
                                    {numeroDaPagina}
                                </button>
                                {numeroDaPagina + 1 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 1)}>
                                        {numeroDaPagina + 1}
                                    </button>
                                )}
                                {numeroDaPagina + 2 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 2)}>
                                        {numeroDaPagina + 2}
                                    </button>
                                )}
                                {numeroDaPagina + 3 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 3)}>
                                        {numeroDaPagina + 3}
                                    </button>
                                )}
                                {numeroDaPagina + 4 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 4)}>
                                        {numeroDaPagina + 4}
                                    </button>
                                )}
                                {numeroDaPagina + 5 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 5)}>
                                        {numeroDaPagina + 5}
                                    </button>
                                )}
                                {numeroDaPagina + 6 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 6)}>
                                        {numeroDaPagina + 6}
                                    </button>
                                )}
                                {numeroDaPagina + 7 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 7)}>
                                        {numeroDaPagina + 7}
                                    </button>
                                )}
                                {numeroDaPagina + 8 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 8)}>
                                        {numeroDaPagina + 8}
                                    </button>
                                )}
                                {numeroDaPagina + 9 > numeroTotalPaginas ? null : (
                                    <button onClick={() => PaginaAtual(numeroDaPagina + 9)}>
                                        {numeroDaPagina + 9}
                                    </button>
                                )}
                                {numeroDaPagina !== numeroTotalPaginas &&
                                    numeroTotalPaginas > 5 ? (
                                    <h3>...</h3>
                                ) : null}
                                {numeroDaPagina !== numeroTotalPaginas &&
                                    numeroTotalPaginas > 5 ? (
                                    <button onClick={() => PaginaAtual(numeroTotalPaginas)}>
                                        {numeroTotalPaginas}
                                    </button>
                                ) : null}
                            </Paginas>
                            {numeroTotalPaginas > numeroDaPagina ? (
                                <BotoesNavegar
                                    type="button"
                                    onClick={() => PaginaAtual(numeroDaPagina + 1)}
                                >
                                    <img src={Next} alt="Avançar" />
                                </BotoesNavegar>
                            ) : null}
                            <Buscar2>
                                <input
                                    type="number"
                                    placeholder="Página..."
                                    onChange={(event) => {
                                        SearchPagina(event.target.value);
                                    }}
                                />
                            </Buscar2>
                        </InlineStylePages>
                    )}
                    <RowButtonsOrderby>
                        <ButtonOrderBy
                            onPress={() => {
                                onPressButtonOrder("nome");
                            }}
                            title={
                                typeOrder === "ascendent"
                                    ? "clique para ordenar de forma descendente"
                                    : "clique para ordenar de forma ascendete"
                            }
                            isSelected={orderBySelect === "nome" ? true : false}
                            type="string"
                            ascendent={typeOrder}
                            text="Nome"
                        />
                        <ButtonOrderBy
                            onPress={() => {
                                onPressButtonOrder("marca");
                            }}
                            title={
                                typeOrder === "ascendent"
                                    ? "clique para ordenar de forma descendente"
                                    : "clique para ordenar de forma ascendete"
                            }
                            isSelected={orderBySelect === "marca" ? true : false}
                            type="string"
                            ascendent={typeOrder}
                            text="Marca"
                        />
                        <ButtonOrderBy
                            onPress={() => {
                                onPressButtonOrder("created_at");
                            }}
                            title={
                                typeOrder === "ascendent"
                                    ? "clique para ordenar de forma descendente"
                                    : "clique para ordenar de forma ascendete"
                            }
                            isSelected={orderBySelect === "created_at" ? true : false}
                            type="string"
                            ascendent={typeOrder}
                            text="Data de Envio"
                        />
                    </RowButtonsOrderby>
                    <HeaderTable backgroundColor="#ADB9AB">
                        <ContainerHeaderTable
                            width="32"
                            justify="start"
                            marginLeft={30}
                            marginRight={10}
                        >
                            <TextHeaderTable>Nome</TextHeaderTable>
                        </ContainerHeaderTable>
                        <ContainerHeaderTable
                            width="29"
                            justify="center"
                            marginLeft={0}
                            marginRight={10}
                        >
                            <TextHeaderTable>Marca</TextHeaderTable>
                        </ContainerHeaderTable>
                        {/* Coluna extra para Status/Lock se necessário no header */}
                        <ContainerHeaderTable
                            minWidth="130"
                            justify="space-evenly"
                            marginLeft={0}
                            marginRight={30}
                        >
                            <TextHeaderTable>Opções</TextHeaderTable>
                        </ContainerHeaderTable>
                    </HeaderTable>
                    {isEmpty ? (
                        <h1>Ainda não há dados nesta página</h1>
                    ) : (
                        <Box style={{ backgroundColor: "#879F85" }}>
                            {requisicao.map((sugestao) => (
                                <div key={sugestao.id}>
                                    <BoxRequisicao
                                        id={sugestao.id}
                                        nome={sugestao.nome}
                                        marca={sugestao.marca}
                                        categoria={sugestao.categoria}
                                        descricao={sugestao.descricao}
                                        imagem1={sugestao.image1_url}
                                        imagem2={sugestao.image_url}
                                        score={sugestao.score}
                                        ingredientes={sugestao.ingredientes_texto}
                                        upc={sugestao.upc}
                                        volume={sugestao.volume}
                                        name={sugestao.usuario?.first_name}
                                        email={sugestao.usuario?.email}
                                        status={sugestao.status_requisicao}
                                        membroResponsavel={sugestao.membro_responsavel}
                                        dataCriacao={sugestao.created_at}
                                        getRecomendations={getRecomendations}
                                    />
                                </div>
                            ))}
                        </Box>
                    )}
                </Tela>
            </div>
        </>
    );
}
export default Requisicoes;